export function stringToCode(str: string, expectedLength: number) {
  return Array.from(str).concat(Array(expectedLength - str.length).fill(''))
}

export function emptyStringArray(length: number) {
  return Array<string>(length).fill('')
}

export function findLastValidInput(code: string[]) {
  const reversedLastIndex = [...code].reverse().findIndex((v) => v !== '')
  return reversedLastIndex > -1
    ? code.length - 1 - reversedLastIndex
    : reversedLastIndex
}

export function codeToString(code: string[]) {
  return code.filter((v) => !!v).join('')
}
